function fetchDataTotal() {
  return (dispatch) => {
    console.log(true)
    fetch('https://indonesia-covid-19.mathdro.id/api/')
      .then(res => res.json())
      .then(data => {
        dispatch({
          type: 'SET_DATA_TOTAL',
          payload: data
        })
      })
      .catch(err => console.log(err))
      .finally(() => {
        dispatch({
          type: 'SET_DATA_TOTAL_LOADING',
          args: false
        })
      })
  }
}

export default fetchDataTotal